import { CSSProperties } from "react";
import { useTranslation } from "react-i18next";

import { getModuleVideoSummary } from "@/domains/certifications/utils";
import { HowItWorksProps } from "@/features/certifications/details/components/types";

import "./styles.css";

const HowItWorks = ({ modules, contentKey }: HowItWorksProps) => {
  const { t } = useTranslation();
  const orderedModules = [...modules].sort((a, b) => a.order - b.order);

  return (
    <section className="flex flex-col gap-400">
      <div className="flex flex-col gap-200">
        <h2 className="certification-section-title header-l-medium">
          {t("certification.details.howItWorksTitle")}
        </h2>

        <p className="certification-section-description body-s-regular">
          {t(`${contentKey}.howItWorksIntro`)}
        </p>
      </div>

      <ol
        className="certification-modules"
        style={
          {
            "--module-count": Math.max(orderedModules.length, 1),
          } as CSSProperties
        }
      >
        {orderedModules.map((module, index) => {
          const position = index + 1;
          const { videoCount, totalMinutes } = getModuleVideoSummary(module);
          const blurb = t(`${contentKey}.modules.${module.slug}.summary`, {
            defaultValue: "",
          });

          return (
            <li
              key={module.id}
              className="certification-module flex flex-col gap-200"
            >
              <span className="certification-module-number flex-inline items-center justify-center body-xs-regular">
                {position}
              </span>

              <h3 className="certification-module-title body-s-medium">
                {module.title}
              </h3>

              {blurb && (
                <p className="certification-module-blurb body-xs-regular">
                  {blurb}
                </p>
              )}

              <span className="certification-module-meta body-xs-regular">
                {t("certification.labels.moduleMeta", {
                  videos: t("certification.labels.videoCount", {
                    count: videoCount,
                  }),
                  minutes: totalMinutes,
                })}
              </span>
            </li>
          );
        })}
      </ol>
    </section>
  );
};

export default HowItWorks;
